export default __webpack_public_path__ + "static/media/icon.31962b09.png";